<div class="kt-portlet">
    <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">
                Jüri Başvuru Formu Dolduranlar Listesi
            </h3>
        </div>
    </div>
    <div class="kt-portlet__body">
        <div class="kt-section">
            <div class="kt-section__content">

                <div class="kt-pagination  kt-pagination--brand">
                    <ul class="kt-pagination__links">
                    </ul>
                </div>
                
                <div class="form-group row">
                    <div class="col-lg-12">
                            <button class="btn btn-outline-dark ml-3" (click)="excelExport()">Excel oluştur</button>
                            <a href="{{assetsPath + excelPath}}" target="_blank" class="btn btn-outline-success ml-3" *ngIf="excelPath">Excel indir</a>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Ad soyad</th>
                                <th>Son form güncelleme tarihi</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let form of judgeForms;">
                                <td><a [routerLink]="['/view-profile/'+form.id]" target="_blank">{{form.displayName}}</a></td>
                                <td>{{form.creationDate}}</td>
                                <td><button class="btn btn-success mr-2"
                                    [routerLink]="['/view-profile/'+form.id]" target="_blank"><i
                                    class="fa fa-info-circle"></i>Form detaylarını görüntüle</button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>